<template>
    <div>
        <compWrapper title="基本信息" theme="primary" >
            <compFormQuery
                v-if="type=='query'"
                class="margin-layout width-50per"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
                placeholder="--"
                :col="1"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-layout width-50per"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
                :col="1"
            />
            <div class="text-right padding-bottom-20 padding-right-20" v-if="type!='query'">
                <Button type="primary" @click="submit">保存</Button>
                <Button class="margin-left-10" @click="cancel">取消</Button>
            </div>
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper title="操作历史" theme="gray" v-if="type=='query'">
            <compLog class="margin-15" :data="opLogList" :columns="getLogcolumns"></compLog>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { HttpSavebillNameOne, HttpGetBillNameOne } from "@/service/newbigaccount";
import { HttpGetLog } from "@/service/fedex";
export default {
    props:['activeids','querytype'],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeids,
            formData:{},
            loading:false,
            opLogList:[],
        }
    },
     computed:{
        ...mapGetters('dictionary', ['getCarrierAllList','getCarrierServiceList']),
        getBase(){
            return [
                {
                    label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    key: 'carrier',
                    tag: 'Select',
                    options:this.getCarrierAllList,
                    props:{
                        filterable:true
                    },
                    query:this.type!='add'
                },
                {
                    label: '费用名称',
                    key: 'costName',
                },
                {
                    label: '费用分类',
                    tag: 'vInput',
                    key: 'costCategory',
                },
            ]
        },
        getLogcolumns(){
			return [
				{
					title: this.$t('global.common.operator', { defaultValue: '操作人' }),
					key: "opUserName"
				},
				{
					title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
					key: "opAction"
				},
				{
					title: this.$t('fbb.basicdata.carrier_change_field', { defaultValue: '更改字段' }),
					key: "changeField"
				},
				{
					title: this.$t('fbb.basicdata.carrier_change_before', { defaultValue: '更改前值' }),
					key: "beforeChange"
				},
				{
					title: this.$t('fbb.basicdata.carrier_change_after', { defaultValue: '更改后值' }),
					key: "afterChange"
				},
				{
					title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
					key: "opAt"
				}
			];
		}
    },
    created(){
        this.update();
    },
    methods:{
        update(){
            if(this.querytype){
				this.type = this.querytype
            }else{
				this.type = this.type
			}
            HttpGetBillNameOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data
            })
            if(this.type=='query'){
				// 请求日志的接口
				HttpGetLog({
					id:this.id,
					module:51,
				}).then(res=>{
					this.opLogList = res.data
				},err=>{
	
				})
			}
        },
        async submit(){
            const valid = await this.$refs.editform.validate();
            if (!valid) return;
            
            this.loading = true;
            HttpSavebillNameOne({
                ...this.formData
            }).then(res=>{
                this.$VMessage.success(res.message);
                this.cancel()
                this.loading = false;
            },err=>{
                this.loading = false;
                this.$VMessage.error(err.message);
            })
        },
        cancel(){
            this.$router.push({
                name: 'bigaccountBillname',
                params: { type: 'add' },
            });
        }
    }
}
</script>